// extracted by mini-css-extract-plugin
export var backTo = "footer-module--backTo--66130";
export var bottom = "footer-module--bottom--d00f2";
export var column = "footer-module--column--a0745";
export var contactUs = "footer-module--contactUs--a52a2";
export var footer = "footer-module--footer--ac64d";
export var logo = "footer-module--logo--62dd1";
export var nav = "footer-module--nav--c76ef";
export var row = "footer-module--row--31979";